import { combineReducers } from 'redux'
// import homeReducer from './../components/home/home.reducer'
import auctionReducer from './../components/auctions/auctions.reducer'
import nftReducer from './../components/nfts/nfts.reducer'
import userReducer from './../components/user/user.reducer'
import walletReducer from './../components/wallet/wallet.reducer'
import categoryReducer from './../components/categories/categories.reducer'
import collectionReducer from './../components/collections/collections.reducer'
import errorReducer from './shared/error/error.reducer'
import settingsReducer from '../components/home/footer/footer.reducer'
import faqReducer from '../components/faq/faq.reducer'
import offersReducer from '../components/offers/offers.reducer'
import bidsReducer from '../components/bids/bids.reducer'
import navBarReducer from '../components/home/navBar/navBar.reducer'
import ImagibleItemsReducer from '../components/home/ImagibleItems/ImagibleItems.reducer'
import contactsReducer from '../components/contact/contact.reducer'
import activityReducer from '../components/activity/activity.reducer'
import rankingsReducer from '../components/rankings/rankings.reducer'
import appReducer from '../App.reducer'
import integrationReducer from '../components/integration/integration.reducer'
import nftHistoryReducer from '../components/history/history.reducer'
import modalMenuReducer from '../components/modal-menu/modal-menu.reducer'

export default combineReducers({
    // home: homeReducer,
    auction: auctionReducer,
    nft: nftReducer,
    user: userReducer,
    wallet: walletReducer,
    category: categoryReducer,
    collection: collectionReducer,
    error: errorReducer,
    settings: settingsReducer,
    faqs: faqReducer,
    offer: offersReducer,
    bid: bidsReducer,
    navBar: navBarReducer,
    explore: ImagibleItemsReducer,
    contact: contactsReducer,
    activities: activityReducer,
    rankings: rankingsReducer,
    app: appReducer,
    integration: integrationReducer,
    nftHistory: nftHistoryReducer,
    modalMenu: modalMenuReducer
})